import React, { useEffect, useState } from "react";
import Project from "./Project/Project";
import "./Projects.css";
const Projects = () => {
  const [projects, setProjects] = useState([]);
  // getting all projects
  useEffect(() => {
    fetch("projects.json")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, []);
  
  return (
    <>
      <div className=" projects">
        <div className="row text-center pt-5 fw-bold text-white">
          <h1 className="mb-4">My Recent Works</h1>
          <p>Here are a few design and functional Projects I've worked on recently</p>
        </div>
        <div className=" projects-container  container mx-auto pb-5">
          <div className="row g-4 project-container mt-4 ">
            {projects.map((project) => (
              <Project project={project} key={Project.id}></Project>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Projects;
